import { slugifyServiceLabel } from './translateService';

/** Translate wizard step question/option labels; canonical French values stay in form state. */
export function translateWizardLabel(t, label) {
  if (label == null) return '';
  const text = String(label);
  if (!text.trim()) return text;
  const slug = slugifyServiceLabel(text);
  const key = `wizardQ.${slug}`;
  const val = t(key);
  if (val !== key) return val;
  return text;
}

export function translateWizardOption(t, option) {
  if (option == null) return '';
  if (typeof option === 'string') return translateWizardLabel(t, option);
  if (typeof option === 'object' && option.label) {
    return { ...option, label: translateWizardLabel(t, option.label) };
  }
  if (typeof option === 'object' && option.title) {
    return { ...option, title: translateWizardLabel(t, option.title) };
  }
  return option;
}
